import React, { useState } from 'react';
import { FormHelperText, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@mui/x-date-pickers';
import { makeOptional } from '../Fields';

interface DataTypeInputDateTimeProps {
  disabled?: boolean;
  value: string;
  id: string;
  name: string;
  label?: string;
  className?: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  error?: boolean;
  helperText?: string;
  optional?: boolean;
}

export const DataTypeInputDate = React.forwardRef<
  HTMLDivElement,
  DataTypeInputDateTimeProps
>(
  (
    {
      disabled,
      value,
      id,
      name,
      label,
      className,
      onChange,
      autoFocus = true,
      error,
      helperText,
      optional,
    },
    ref,
  ) => {
    const { t } = useTranslation(['general']);
    const [dateValue, setDateValue] = useState<Date | null>(
      value ? new Date(value) : null,
    );

    const handleDateChange = (date: Date | null) => {
      if (!date || String(date) === 'Invalid Date') return;
      setDateValue(date);
      onChange(date.toISOString());
    };
    return (
      <>
        <InputLabel shrink htmlFor={id}>
          {optional ? makeOptional(t, label) : label}
        </InputLabel>
        <DatePicker
          ref={ref}
          disabled={disabled}
          slotProps={{
            textField: {
              id,
              name,
              className,
              fullWidth: true,
              error,
            },
          }}
          autoFocus={autoFocus}
          value={dateValue}
          format="dd-MM-yyyy"
          onChange={handleDateChange}
        />
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </>
    );
  },
);

DataTypeInputDate.displayName = 'DataTypeInputDate';
